app.factory('loginService', function($http) {
    return {
        get: function() {
            return $http.get('/user/current');
        }
    };
});
